import React, { useState } from 'react';
import InputField from '../../../../ui-core/InputField';
import Button from '../../../../ui-core/Button/Button';
import { createSubscriptionRequest } from '../../../../api/subscribe';
const EmailForm = () => {
  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const isValidEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  return alreadySubscribed ? (
    <div className="w-100">Subscribed successfully</div>
  ) : (
    <>
      <InputField
        name="email"
        placeholder="Enter Your Email Address"
        type="text"
        className="form-control-survey form-control"
        style="border: 1px solid rgb(20, 20, 43);"
        value={emailValue}
        handleChange={ev => setEmailValue(ev.target.value)}
      />
      <Button
        class="btn-style"
        isLoading={subscribeLoading}
        isDisabled={!isValidEmail(emailValue)}
        text="SUBMIT"
        onClick={async () => {
          try {
            if (emailValue && isValidEmail(emailValue)) {
              setSubscribeLoading(true);
              const response = await createSubscriptionRequest({
                email: emailValue,
              });
              if (response?.data?.response?.data?.registered_user) {
                setAlreadySubscribed(true);
              }
              setSubscribeLoading(false);
            }
          } catch (error) {
            setSubscribeLoading(false);
            console.error(error);
          }
        }}
      />
    </>
  );
};

export default EmailForm;
